import Routes from '../constants/routes';
import isMobileAppWebview from './is-mobile-app-webview';
import serializeQueryParams from './url/serialize-query-params';

type Component = {
    appBanner: boolean;
    footer: boolean;
    header: boolean;
    stiftungHeader: boolean;
    menu: boolean;
    footerClass?: string;
    headerClass?: string;
    marchVoucherCampaign?: boolean;
    marketingBar?: boolean;
};

const renderPermissions = (): Component => {
    const components: Component = {
        appBanner: false,
        footer: true,
        header: true,
        menu: true,
        marketingBar: true,
        stiftungHeader: false
    };

    const path = window.location.pathname;
    const queryParams = serializeQueryParams();
    const isMobileApp = isMobileAppWebview();

    if (
        path === Routes.RATING_EMAIL_LANDING.path ||
        path === Routes.AUTHORIZE.path ||
        path === Routes.LOGIN_AS.path ||
        path === Routes.ABANDONED_CART_REDIRECT.path ||
        path === Routes.MICROSOFT_REDIRECT_URI.path ||
        path === Routes.FILL_PERSONALIZATION_REDIRECT.path ||
        path.includes(Routes.MATERIAL_CARD_PREVIEW.path.replace('/:id', ''))
    ) {
        components.footer = false;
        components.header = false;
    }

    if (path === Routes.WARENKORB.path) {
        components.headerClass = 'd-none d-lg-flex';
        components.footerClass = 'cart-mobile-footer';
    }

    if (path === Routes.PAYMENT.path) {
        components.footer = false;
        components.headerClass = 'd-none';
        components.marketingBar = false;
    }

    // Hide marketing bar on landing during marketing campaigns
    if (window.location.pathname.indexOf(Routes.LANDING.prefix) >= 0 && queryParams.l_campaign) {
        components.marketingBar = false;
    }

    if (isMobileApp) {
        components.headerClass = 'd-none';
        components.footer = false;
        components.appBanner = false;
        components.marketingBar = false;
    }

    if (window.location.pathname.indexOf(Routes.FREE_MATERIALS_LANDING.path) >= 0) {
        components.footer = false;
        components.stiftungHeader = true;
    }

    if (
        [
            Routes.NEW_INTERACTIVE_MATERIALS.path,
            Routes.NEW_INTERACTIVE_MY_MATERIALS.path,
            Routes.NEW_INTERACTIVE_ROOMS.path,
            Routes.NEW_INTERACTIVE_COURSES.path
        ].some((route) => decodeURIComponent(window.location.pathname).includes(route))
    ) {
        components.menu = false;
        components.footer = false;
        components.marketingBar = false;
    }

    if (
        [Routes.AI_TOOLS.path, Routes.AI_TOOLS_DOCUMENTS.path, Routes.AI_TOOLS_FAQ.path].some((route) =>
            decodeURIComponent(window.location.pathname).includes(route)
        )
    ) {
        components.menu = false;
        components.footer = true;
        components.marketingBar = false;
    }

    return components;
};

export default renderPermissions;
